import { render, staticRenderFns } from "./RingAppControlCenterInstructions.vue?vue&type=template&id=4c60f17c&scoped=true&"
import script from "./RingAppControlCenterInstructions.vue?vue&type=script&lang=js&"
export * from "./RingAppControlCenterInstructions.vue?vue&type=script&lang=js&"
import style0 from "./RingAppControlCenterInstructions.vue?vue&type=style&index=0&id=4c60f17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60f17c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c60f17c')) {
      api.createRecord('4c60f17c', component.options)
    } else {
      api.reload('4c60f17c', component.options)
    }
    module.hot.accept("./RingAppControlCenterInstructions.vue?vue&type=template&id=4c60f17c&scoped=true&", function () {
      api.rerender('4c60f17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/ring/RingAppControlCenterInstructions.vue"
export default component.exports